import { SuggestionTypes, ProviderFacetGroups } from 'store/providerSearch/types';
import { currentLocation } from 'store/providerSearch/constants';
import { RecentSearch } from 'storage/recentSearches/common';
import React from 'mobile/node_modules/@types/react-native-vector-icons/node_modules/@types/react';
import { sortByDate } from './utils';

//
//  Constant: commonSearches
//  Description: The common searches structure to use for quickLinks function, please make additions in alphabetical order
//
export const commonSearches = {
  dermatology: {
    value: 'Dermatology',
    category: SuggestionTypes.COMMON_SEARCHES,
    params: {
      options: {
        facets: [
          {
            group: ProviderFacetGroups.specialty,
            value: 'Dermatology',
            title: 'Dermatology'
          }
        ]
      }
    }
  },
  familyMedicine: {
    value: 'Family Medicine',
    category: SuggestionTypes.COMMON_SEARCHES,
    accebilityLabel: 'Family Medicine',
    params: {
      options: {
        facets: [
          {
            group: ProviderFacetGroups.specialty,
            value: 'Family Medicine',
            title: 'Family Medicine'
          }
        ]
      }
    }
  },
  gastroenterology: {
    value: 'Gastroenterology',
    category: SuggestionTypes.COMMON_SEARCHES,
    params: {
      options: {
        facets: [
          {
            group: ProviderFacetGroups.specialty,
            value: 'Gastroenterology',
            title: 'Gastroenterology'
          }
        ]
      }
    }
  },
  internalMedicine: {
    value: 'Internal Medicine',
    category: SuggestionTypes.COMMON_SEARCHES,
    params: {
      options: {
        facets: [
          {
            group: ProviderFacetGroups.specialty,
            value: 'Internal Medicine',
            title: 'Internal Medicine'
          }
        ]
      }
    }
  },
  neurology: {
    value: 'Neurology',
    category: SuggestionTypes.COMMON_SEARCHES,
    params: {
      options: {
        facets: [
          {
            group: ProviderFacetGroups.specialty,
            value: 'Neurology',
            title: 'Neurology'
          }
        ]
      }
    }
  },
  obgyn: {
    value: 'Obstetrics and Gynecology',
    category: SuggestionTypes.COMMON_SEARCHES,
    params: {
      options: {
        facets: [
          {
            group: ProviderFacetGroups.specialty,
            value: 'Obstetrics and Gynecology',
            title: 'Obstetrics and Gynecology'
          }
        ]
      }
    }
  },
  orthopedicSurgery: {
    value: 'Orthopedic Surgery',
    category: SuggestionTypes.COMMON_SEARCHES,
    params: {
      options: {
        facets: [
          {
            group: ProviderFacetGroups.specialty,
            value: 'Orthopedic Surgery',
            title: 'Orthopedic Surgery'
          }
        ]
      }
    }
  },
  pediatrics: {
    value: 'Pediatrics',
    category: SuggestionTypes.COMMON_SEARCHES,
    params: {
      options: {
        facets: [
          {
            group: ProviderFacetGroups.specialty,
            value: 'Pediatrics',
            title: 'Pediatrics'
          }
        ]
      }
    }
  },
  urology: {
    value: 'Urology',
    category: SuggestionTypes.COMMON_SEARCHES,
    params: {
      options: {
        facets: [
          {
            group: ProviderFacetGroups.specialty,
            value: 'Urology',
            title: 'Urology'
          }
        ]
      }
    }
  }
};

export const getRecentSearches = (searches: RecentSearch[] = []) => {
  return searches.sort(sortByDate).reduce(
    (acc, { searchQuery, searchParams }) => ({
      ...acc,
      [searchQuery]: {
        value: searchQuery,
        category: SuggestionTypes.RECENT_SEARCHES,
        params: {
          requireAuth: false,
          recentSearch: true,
          options: searchParams
        }
      }
    }),
    {}
  );
};

export const nearMe = {
  nearMeSearch: {
    value: 'Near Me',
    category: SuggestionTypes.QUICKLINK,
    params: {
      options: {
        locationText: currentLocation,
        orderBy: 'proximity',
        facets: [
          {
            title: 'Any',
            group: ProviderFacetGroups.locationDistance,
            value: 9999
          }
        ]
      }
    }
  }
};

export const mobileLinks = () =>
  ({
    recentSearches: (searches: RecentSearch[] = []) => getRecentSearches(searches),
    ...commonSearches,
    ...nearMe
  } as const);

//
//  Function: quickLinks
//  Description: Generates a constant that is the structure to use for both mobile and web Provider Search Quick Links
//
export const quickLinks = (setLinks: React.SetStateAction<any>) =>
  ({
    recentSearches: (searches: RecentSearch[] = [], loading = false) => {
      if (loading) {
        return {
          value: 'Loading...',
          category: SuggestionTypes.QUICKLINK,
          params: {
            disabled: true
          }
        };
      }

      if (!searches || !searches.length) {
        return {
          value: 'No Recent Searches',
          category: SuggestionTypes.QUICKLINK,
          params: {
            disabled: true
          }
        };
      }

      return {
        value: 'Recent Searches',
        category: SuggestionTypes.QUICKLINK,
        params: {
          requireAuth: true
        },
        onClick: () => {
          setLinks(getRecentSearches(searches));
        }
      };
    },
    commonSearches: {
      value: 'Common Searches',
      category: SuggestionTypes.QUICKLINK,
      onClick: () => {
        setLinks(commonSearches);
      }
    },
    ...nearMe,
    specialtiesSearch: {
      value: 'Specialties',
      category: SuggestionTypes.QUICKLINK,
      params: {
        defaultExpandedFilters: ['specialties']
      }
    }
  } as const);
